import { Controller } from "stimulus"
import { trackEvent } from '../../src/javascripts/tracking'

// A Stimulus controller to send events based on data attributes
export default class extends Controller {
  static values = {
    name: String,
    properties: Object,
    trigger: String
  }

  connect() {
    if (!this.isValid()) return
  
    if (this.triggerValue == "onload") {
      return this.handleEvent()  // Trigger immediately on connect
    }

    // Bind the handler once for correct removal later
    this.boundHandler = this.handleEvent.bind(this)
    this.element.addEventListener(this.triggerValue, this.boundHandler)
  }

  disconnect() {
    if (this.boundHandler) {
      this.element.removeEventListener(this.triggerValue, this.boundHandler)
    }
  }

  // Validates required values
  isValid() {
    if (!this.nameValue || !this.triggerValue) {
      console.warn(
        "[Track Event Controller] Missing required values (name or trigger):",
        this.element
      )
      return false
    }
    return true
  }

  // Event handler for triggering event capture
  handleEvent(event) {
    try {
      // If link opens in new tab, prevent default and delay navigation
      if (this.element.target === '_blank' && this.triggerValue === 'click') {
        event.preventDefault()

        // Open blank window immediately (preserves user gesture)
        const newWindow = window.open('', '_blank')
  
        trackEvent(this.nameValue, this.propertiesValue)
        
        // Navigate the new window after tracking
        setTimeout(() => {
          if (newWindow) {
            newWindow.location.href = this.element.href
          }
        }, 100)
      } else {
        trackEvent(this.nameValue, this.propertiesValue)
      }
      console.log(`[Track Event] captured: ${this.nameValue}`)
    } catch (error) {
      console.error("[Track Event] Failed to capture:", error)
    }
  }
}